const axios = require('axios');

export function updateAPI(data) {
  return new Promise(function(resolve, reject) {
    axios.post(process.env.APP_URL + 'api/update.php?', JSON.stringify(data))
      .then(function(response) {
        let data = response.data;
        resolve(data);
      })
      .catch(function(error) {

        reject(error);
      })
  })
}

export function getItem(id) {
  return new Promise(function(resolve, reject) {
    axios.get(process.env.APP_URL + 'api/get_item.php?id=' + id)
      .then(function(response) {
        let data = response.data;
        resolve(data);
      })
      .catch(function(error) {

        reject(error);
      })
  })
}

export function getHouseData(dispatchDate) {
  return new Promise(function(resolve, reject) {
    axios.get(process.env.APP_URL + 'api/houseData.php?dispatch_date=' + dispatchDate)
      .then(function(response) {
        let data = response.data;
        resolve(data);
      })
      .catch(function(error) {

        reject(error);
      })
  })
}



// WEBPACK FOOTER //
// ./src/api/general.js